import { render } from "./PanelAdminFAQ.vue?vue&type=template&id=3b381a0a&ts=true"
import script from "./PanelAdminFAQ.vue?vue&type=script&lang=ts"
export * from "./PanelAdminFAQ.vue?vue&type=script&lang=ts"

import "./PanelAdminFAQ.vue?vue&type=style&index=0&id=3b381a0a&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__